import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const UserIcon = forwardRef(({ title = 'User Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 14 14" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M4.3 3.62v-.24C4.3 1.68 5.4.5 7 .5s2.7 1.18 2.7 2.88v.24C9.7 5.32 8.6 6.5 7 6.5S4.3 5.32 4.3 3.62m9 6.67a.7.7 0 0 0-.3-.44C12.26 9.36 9.95 8 7 8S1.74 9.36 1 9.85a.7.7 0 0 0-.3.44L.01 13.1c-.11.47.31.9.88.9h12.2c.57 0 1-.43.88-.9z" })));
});
//# sourceMappingURL=user_icon.js.map